import dropdowncss from "../css/dropdown.module.css";
import commoncss from "../css/common.module.css";
import { useEffect, useState, useRef } from "react";
import { ReactComponent as DownArrowIcon } from "../assets/icons/down_arrow.svg";
import { ReactComponent as UpArrowIcon } from "../assets/icons/up_arrow.svg";
import { ReqFieldLabel } from "../../myfin_v2/components/mis";

export default function Dropdown({
  req = false,
  class_ = "",
  class2_ = "",
  label,
  options = [],
  onSelect,
  placeHolder,
  selected = {},
  selValue = null,
}) {
  const [open, setOpen] = useState(false);
  const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (options.length === 1) {
      const labelToSet = options[0].label;
      if (selectedOptionLabel !== labelToSet) {
        setSelectedOptionLabel(labelToSet);
        onSelect &&
          onSelect({ label: options[0].label, value: options[0].value });
      }
    } else if (selValue) {
      const matchedOption = options.find(
        (opt) =>
          String(opt.value).toLowerCase() === String(selValue).toLowerCase()
      );
      if (matchedOption) {
        // ✅ Always set — no guard — so it syncs whenever options or selValue changes
        setSelectedOptionLabel(matchedOption.label);
      } else {
        setSelectedOptionLabel(null);
      }
    } else if (selected && selected.label && selected.label !== selectedOptionLabel) {
      setSelectedOptionLabel(selected.label);
    } else if (!selValue && !selected?.label) {
      setSelectedOptionLabel(null);
    }
    // ✅ Only depends on external inputs, not internal state (selectedOptionLabel)
    // This prevents the stale closure bug that blocked re-renders
  }, [options, selected, selValue]);

  const handleSelect = (option) => {
    onSelect && onSelect({ label: option.label, value: option.value });
    setSelectedOptionLabel(option.label);
    setOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      className={`${dropdowncss.dropdown_wrapper} ${class_}`}
    >
      {label && (
        <span className={dropdowncss.dropdown_label}>
          {req && <ReqFieldLabel />} &nbsp; {label}
        </span>
      )}
      <div
        className={`${dropdowncss.dropdown} ${class_}`}
        onClick={() => setOpen(!open)}
      >
        <div
          className={`${class2_} ${dropdowncss.dropdown_selected} ${
            selectedOptionLabel ? dropdowncss.has_value : ""
          }`}
          {...(selectedOptionLabel
            ? { "data-tooltip": selectedOptionLabel }
            : {})}
        >
          <span className={dropdowncss.dropdown_selected_text}>
            {selectedOptionLabel || placeHolder}
          </span>
          <span className={dropdowncss.dropdown_arrow}>
            {open ? <UpArrowIcon /> : <DownArrowIcon />}
          </span>
        </div>

        <div
          className={`${dropdowncss.dropdown_menu} ${
            open ? dropdowncss.open : ""
          }`}
        >
          {options.map((opt, i) => (
            <div
              key={i}
              className={dropdowncss.dropdown_item}
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}